import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { monthLabel, monthPhase, currentMonthKey } from '../../lib/months';

type Props = { months: string[] };

// Spalten-Header der Timeline: 18 Monate horizontal.
// "now" = aktueller Monat (Primary-Untermalung), "past" / "future" dezenter.
export function MonthsHeader({ months }: Props) {
  const cur = currentMonthKey();
  return (
    <Box
      role="row"
      sx={{
        display: 'grid',
        gridTemplateColumns: `200px repeat(${months.length}, minmax(60px, 1fr)) 70px`,
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        position: 'sticky',
        top: 0,
        zIndex: 2,
      }}
    >
      <Box sx={{ p: 1, fontSize: 11, fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.4 }}>
        Gruppe / Zeile
      </Box>
      {months.map(mk => {
        const phase = monthPhase(mk, cur);
        return (
          <Box
            key={mk}
            sx={{
              p: 0.75,
              textAlign: 'center',
              borderLeft: 1,
              borderColor: 'divider',
              bgcolor: phase === 'now' ? 'primary.main' : 'transparent',
              color:   phase === 'now' ? 'primary.contrastText'
                     : phase === 'past' ? 'text.secondary' : 'text.primary',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: phase === 'now' ? 700 : 500 }}>
              {monthLabel(mk)}
            </Typography>
          </Box>
        );
      })}
      <Box sx={{ p: 0.75, textAlign: 'center', borderLeft: 1, borderColor: 'divider' }}>
        <Typography variant="caption" sx={{ fontWeight: 600 }}>Σ</Typography>
      </Box>
    </Box>
  );
}
